import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CadensCandidatureModule} from './candidature/candidature.module';
import {CadensParametrageModule} from './parametrage/parametrage.module';
import {CadensLegalModule} from './legal/legal.module';
import {CadensContactModule} from './contact/contact.module';
import {CadensFaqModule} from './faq/faq.module';
import {CadensCampagneModule} from './campagne/campagne.module';
import {CadensFormationModule} from './formation/formation.module';
import {CadensHistoriqueModule} from './historique/historique.module';
import {CadensPieceJointeModule} from './piece-jointe/piece-jointe.module';
import {CadensGrhumModule} from './grhum/grhum.module';
import {CadensBlocksModule} from './blocks/blocks.module';
import {CadensEspaceCandidatModule} from './espaceCandidat/espaceCandidat.module';
import {CadensCommissionModule} from './commission/commission.module';
import {CadensReferentModule} from './referent/referent.module';
import {CadensEntityAuditEventModule} from './entity-audit-event/entity-audit-event.module';
import {CadensUserEnEchangeModule} from './user-en-echange/user-en-echange.module';
import { CadensAdmisModule } from './admis/admis.module';

/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */

@NgModule({
    imports: [
        CadensCandidatureModule,
        CadensParametrageModule,
        CadensLegalModule,
        CadensContactModule,
        CadensFaqModule,
        CadensCampagneModule,
        CadensFormationModule,
        CadensHistoriqueModule,
        CadensPieceJointeModule,
        CadensGrhumModule,
        CadensReferentModule,
        CadensBlocksModule,
        CadensEspaceCandidatModule,
        CadensCommissionModule,
        CadensEntityAuditEventModule,
        CadensUserEnEchangeModule,
        CadensAdmisModule
        /* jhipster-needle-add-entity-module - JHipster will add entity modules here */
    ],
    declarations: [],
    entryComponents: [],
    exports: [CadensBlocksModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensEntityModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity.module.ts